// TypeScript
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

export function logFormErrors(control: AbstractControl, path: string = ''): void {
  if (control instanceof FormControl) {
    if (control.errors) {
      console.group(`Control: ${path || '<root>'}`);
      console.log('Errors:', control.errors);
      console.log('Value:', control.value);
      console.log('Status:', control.status);
      console.groupEnd();
    }
    return;
  }

  if (control instanceof FormGroup) {
    for (const key of Object.keys(control.controls)) {
      const child = control.controls[key];
      logFormErrors(child, path ? `${path}.${key}` : key);
    }
    if (control.errors) {
      console.group(`Group: ${path || '<root>'}`);
      console.log('Errors:', control.errors);
      console.log('Status:', control.status);
      console.groupEnd();
    }
    return;
  }

  if (control instanceof FormArray) {
    for (let i = 0; i < control.length; i++) {
      const child = control.at(i);
      logFormErrors(child, `${path}[${i}]`);
    }
    if (control.errors) {
      console.group(`Array: ${path || '<root>'}`);
      console.log('Errors:', control.errors);
      console.log('Status:', control.status);
      console.groupEnd();
    }
  }
}
